import React from "react";
import { Menu, Button, Input, VisuallyHidden } from "@chakra-ui/react";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ChevronDown } from "lucide-react";
import { BigNumber } from "ethers";

interface ITokenSelectInput {
  name: string;
  selectedTokenIds?: Array<BigNumber>;
  selectedTokenId?: string;
  sync?: (value: string) => void;
  isDisabled: boolean;
  register: UseFormRegister<any>;
  value: string;
  setValue: UseFormSetValue<any>;
}

const NFTTokenIdSelectInput: React.FC<ITokenSelectInput> = ({
  name,
  selectedTokenIds,
  selectedTokenId,
  sync,
  isDisabled,
  register,
  setValue,
  value,
}: ITokenSelectInput) => {
  const handleClick = (selectedValue: string) => {
    setValue(name, selectedValue, { shouldValidate: true }); // Form validation
    if (sync) {
      sync(selectedValue);
    }
  };

  const labelParsed =
    value !== "" && selectedTokenId
      ? `${selectedTokenId.toString()}`
      : "Select NFT id";

  const tokenIdValidator = register(name);

  return (
    <section>
      <Menu.Root>
        <Menu.Trigger asChild>
          <Button width="100%" disabled={isDisabled}>
            {labelParsed} <ChevronDown size={16} />
          </Button>
        </Menu.Trigger>
        <Menu.Positioner>
          <Menu.Content borderRadius="0px" border="1px solid" width="100%">
            {(selectedTokenIds || []).map((tokenId: BigNumber) => {
              return (
                <Menu.Item
                  value={tokenId.toString()}
                  onClick={handleClick.bind(this, tokenId.toString())}
                  key={"id" + tokenId.toString()}
                >
                  {tokenId.toString()}
                </Menu.Item>
              );
            })}
          </Menu.Content>
        </Menu.Positioner>
      </Menu.Root>
      {/* Hidden text field for form validation: */}
      <VisuallyHidden>
        <Input
          name={name}
          value={selectedTokenId || ""}
          onChange={tokenIdValidator.onChange}
          onBlur={tokenIdValidator.onBlur}
          ref={tokenIdValidator.ref}
        />
      </VisuallyHidden>
    </section>
  );
};

export default NFTTokenIdSelectInput;
